import { DEFAULT_VARIATION_OPTIONS_BY_TYPE } from 'core/common/constants/multivariation'
import i18n from 'core/common/i18n'
import { Box } from 'core/components/Core'
import VariationItemView from 'core/components/Variations/VariationItemView'
import EnhancedProductStatus from '../../../EnhancedProductStatus'

const VariationHeader = ({
  variationGroupName,
  variationGroupList,
  isEditMode,
  customAttributesTypes,
  variationTypes,
  defaultVariationOptionsByType,
}) => {
  const variationGroupType = isEditMode ? customAttributesTypes?.[0] : variationTypes?.first
  const variationGroupTypeBR = i18n.t(`multivariation.types.${variationGroupType}`)

  const getColorOption = (options, title) =>
    options.color.find(colorOption => colorOption.title === title)?.color

  const hasColor =
    getColorOption(
      defaultVariationOptionsByType || DEFAULT_VARIATION_OPTIONS_BY_TYPE,
      variationGroupName
    ) || false

  const variationGroupPayload = {
    label: `${variationGroupTypeBR}: ${variationGroupName}`,
    showAvatar: !!hasColor,
    color: hasColor,
  }

  const firstVariationOfGroup = variationGroupList?.[0]

  return (
    <Box className="d-flex align-center my-3 mr-3 flex-1 justify-between">
      <VariationItemView variation={variationGroupPayload} />
      <div className="d-flex">
        {firstVariationOfGroup?.status && (
          <EnhancedProductStatus status={firstVariationOfGroup.status} />
        )}
      </div>
    </Box>
  )
}

export default VariationHeader
